import { hideLightweightElements } from "@/store/lightweight-elements-slice";
import { changeMode } from "@/store/mode-slice";
import {
  selectActiveElement,
  selectAreaFor,
} from "@/store/selections-selectors";
import { setActiveElement } from "@/store/selections-slice";
import { AppThunk } from "@/store/store";
import { GUID } from "@faro-lotv/foundation";
import { hideIElements, setAreaDataSets } from "@faro-lotv/project-source";
import { DataSetAreaInfo } from "@faro-lotv/service-wires";

/**
 * Restricts the project to the data supported by the report/snapshot tools, by replacing the
 * area datasets and hiding the unsupported elements.
 * If this unlinks the active element from its area (e.g. a scan of a removed dataset or a hidden
 * element), the area itself becomes the active element, so that a current area stays available.
 *
 * @param dataSets The datasets to keep for each area
 * @param hiddenIds The ids of the elements to hide
 * @returns Redux thunk applying the report tool filters
 */
export function applyReportToolFilters(
  dataSets: Record<GUID, DataSetAreaInfo[]>,
  hiddenIds: GUID[],
): AppThunk {
  return (dispatch, getState) => {
    const area = selectAreaFor(selectActiveElement(getState()))(getState());

    dispatch(setAreaDataSets(dataSets));
    dispatch(hideIElements(hiddenIds));
    dispatch(hideLightweightElements(hiddenIds));

    const state = getState();
    if (area && !selectAreaFor(selectActiveElement(state))(state)) {
      dispatch(setActiveElement(area.id));
      dispatch(changeMode("sheet"));
    }
  };
}
